import { render, staticRenderFns } from "./TissueFieldFormGroups.vue?vue&type=template&id=402c18f4"
import script from "./TissueFieldFormGroups.vue?vue&type=script&lang=js"
export * from "./TissueFieldFormGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports